import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const AdminLogin = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const login = () => {
        if (!email || !password) {
            alert('Email and Password required');
            return;
        }

        setLoading(true);

        fetch('https://dirasa.in/api/admin/login.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email: email,
                password: password
            })
        })
        .then(res => res.json())
        .then(data => {
            if (data.status === 'success') {
                localStorage.setItem('admin_token', data.token);
                localStorage.setItem('admin_name', data.name);
                navigate('/admin/dashboard');
            } else {
                alert(data.message || 'Invalid login');
            }
        })
        .catch(err => {
            console.error('Login error:', err);
            alert('Server error');
        })
        .finally(() => {
            setLoading(false);
        });
    };


    return (
        <div style={container}>
            <div style={card}>
                <h4 style={{ textAlign: 'center', marginBottom: 20 }}>Dirasa</h4>
                <h3 style={{ textAlign: 'center', marginBottom: 20 }}>Admin Login</h3>

                <input
                    style={input}
                    type="email"
                    placeholder="Admin Email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                />

                <input
                    style={input}
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                />

                <button
                    style={button}
                    onClick={login}
                    disabled={loading}
                >
                    {loading ? 'Logging in...' : 'Login'}
                </button>
            </div>
        </div>
    );
};

export default AdminLogin;

/* ---------- Styles ---------- */

const container = {
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'linear-gradient(135deg, #c31a1a, #7d0a0a)'
};

const card = {
    background: '#fff',
    padding: '30px',
    borderRadius: '10px',
    width: '100%',
    maxWidth: '380px',
    boxShadow: '0 15px 40px rgba(0,0,0,0.2)'
};

const input = {
    width: '100%',
    padding: '12px',
    marginBottom: '15px',
    borderRadius: '6px',
    border: '1px solid #ccc',
    fontSize: '14px'
};

const button = {
    width: '100%',
    padding: '12px',
    background: '#c31a1a',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    fontSize: '15px',
    fontWeight: '600',
    cursor: 'pointer'
};
